import TableComponent from "../../components/TableComponent";
import { CompanyList } from "../../types/General";

type props = {
  columns: any;
  rows: CompanyList[];
  count: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
};

const NewCompaniesList = ({
  rows,
  columns,
  count,
  page,
  onPageChange,
  loading,
}: props) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          count={count}
          page={page}
          onPageChange={onPageChange}
          loading={loading}
        />
      </div>
    </>
  );
};

export default NewCompaniesList;
